const FALLBACK_LOCALE = 'en-GB'

const COLLATOR_OPTIONS = { sensitivity: 'base', numeric: true }

const createCollator = (locale) => {
    try {
        return new Intl.Collator(locale || FALLBACK_LOCALE, COLLATOR_OPTIONS)
    } catch {
        return new Intl.Collator(FALLBACK_LOCALE, COLLATOR_OPTIONS)
    }
}

const labelText = (option) => String(option.label ?? '')

export const sortOptionsByLabel = (options, locale) => {
    const collator = createCollator(locale)
    const first = options.filter((option) => option.pinned === 'first')
    const last = options.filter((option) => option.pinned === 'last')
    const rest = options.filter((option) => option.pinned !== 'first' && option.pinned !== 'last')

    return [...first, ...rest.sort((a, b) => collator.compare(labelText(a), labelText(b))), ...last]
}
